
// コンボボックス用の選択肢
export const gradeOptions = [
    { value: "all", label: "全学年" },
    { value: 1, label: "小学校1年" },
    { value: 2, label: "小学校2年" },
    { value: 3, label: "小学校3年" },
    { value: 4, label: "小学校4年" },
    { value: 5, label: "小学校5年" },
    { value: 6, label: "小学校6年" },
    { value: 7, label: "中学校1年" },
    { value: 8, label: "中学校2年" },
    { value: 9, label: "中学校3年" },
    { value: 10, label: "高校1年" },
    { value: 11, label: "高校2年" },
    { value: 12, label: "高校3年" },
    { value: 13, label: "既卒" }
];

// タブ用の選択肢
export const gradeTabs = [
    { value: "all", label: "全学年" },
    { value: 1, label: "小1" },
    { value: 2, label: "小2" },
    { value: 3, label: "小3" },
    { value: 4, label: "小4" },
    { value: 5, label: "小5" },
    { value: 6, label: "小6" },
    { value: 7, label: "中1" },
    { value: 8, label: "中2" },
    { value: 9, label: "中3" },
    { value: 10, label: "高1" },
    { value: 11, label: "高2" },
    { value: 12, label: "高3" },
    { value: 13, label: "既卒" }
];

export const filterStudentsFromGrade = (students, selectedGrade) => {
    if (selectedGrade === "all") {
        return students;
    }
    return students.filter(student => student.grade === Number(selectedGrade));
};
